(function () {
  function bind(scope) {
    (scope || document).querySelectorAll('.s2g-mobile-share-inline').forEach(function (button) {
      if (button.dataset.s2gShareBound === 'true') return;
      button.dataset.s2gShareBound = 'true';
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-s2g-share-url') || window.location.href;
        var title = button.getAttribute('data-s2g-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var old = button.textContent;
            button.textContent = 'Copied';
            setTimeout(function () { button.textContent = old || 'Share'; }, 1400);
          });
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
